angular.module('AppCtrl.service', ['AppCtrl.campaign.service']);
angular.module('AppCtrl.directive', ['AppCtrl.jobvite.directive'])
    .directive('onKeyup', function ($parse) {
        return function (scope, elm, attrs) {
            //Evaluate the variable that was passed
            //In this case we're just passing a variable that points
            //to a function we'll call each keyup
            var keyupFn = $parse(attrs.onKeyup);
            elm.on('keyup', function (evt) {
                //$apply makes sure that angular knows
                //we're changing something
                scope.$apply(function () {
                    keyupFn(scope, {
                        keyPressed: evt.which
                    });
                });
            });
        };
    });

var appCtrlModule = angular.module('AppCtrl', ['AppCtrl.service', 'AppCtrl.directive', 'AppCtrl.modals', 'AppCtrl.campaign.constant', 'jv.Common.EmployeeSelect', 'jv.Common.Filters', 'ngRoute', 'jv.Common.MessageBar']);

/*************************************************************/
/******************** Controllers ****************************/
/*************************************************************/

appCtrlModule.controller('CampaignCtrl', ['$scope', '$rootScope', '$document', 'campaignService',
    function ($scope, $rootScope, $document, campaignService) {
        $scope.hasOldCampaigns = false;
        campaignService.checkOldCampaigns(null, function (results) {
            $scope.hasOldCampaigns = results.resultCount;
        });
        campaignService.getCampaigns();
        // click event broadcast
        $document.on('click', function () {
            $rootScope.$broadcast('closeDropDown');
        });

        $scope.isStartDisabled = function(start) {
            return start <= 1;
        };

        $scope.getMilliseconds = function (dateVal) {
            if (dateVal) {
                var d = new Date(dateVal);
                return d.getTime();
            }
        };
    }
]);

/**
 * Grid Filter Controller
 */
appCtrlModule.controller('CampaignFilterCtrl', ['$scope', 'closeFilter', 'openFilter', 'campaignService',
    function ($scope, closeFilter, openFilter, campaignService) {
        var _previousSearch = '';
        $scope.closeFilter = function () {
            closeFilter();
        };
        $scope.openFilter = function () {
            openFilter();
        };

        $scope.handleKeypress = function (key) {
            if (key === 13) {
                getCampaigns();
            }
        };

        $scope.clearSearch = function () {
            $scope.keywords = '';
            if (_previousSearch !== $scope.keywords) {
                getCampaigns();
            }
        };

        $scope.reset = function () {
            window.location = window.location;
        };

        // Makes the copy of the object and sets the page number to zero;
        function getCampaigns(newValue, oldValue) {
            if (typeof newValue !== 'undefined' && typeof oldValue !== 'undefined' && angular.equals(newValue, oldValue)) {
                return;
            }
            var _args = angular.copy($scope.filterObject);
            // changing the filter always sets the page to zero;
            _previousSearch = _args.keywords = $scope.keywords;
            _args.page = 0;
            campaignService.getCampaigns(_args);
        }

        $scope.triggerSearch = function () {
            getCampaigns();
        };

        $scope.filterObject = {};
        $scope.keywords = '';
        $scope.filterObject.status = '';
        $scope.filterObject.type = '';
        $scope.$watch('filterObject', function (newValue, oldValue) {
            getCampaigns(newValue, oldValue);
        }, true);
    }
]);

/**
 * Grid Header Controller
 */
appCtrlModule.controller('CampaignHeaderCtrl', ['$scope', '$rootScope', 'campaignService', 'modalService',
    function ($scope, $rootScope, campaignService, modalService) {
        $scope.pageSize = 10;
        $scope.start = 0;
        $scope.end = 0;
        $scope.total = 0;
        $scope.page = 0;
        var _selectedGridIds = [];
        $scope.hideSelectMsg = true;

        $scope.$on('showSelectionMsg', function () {
            $scope.hideSelectMsg = false;
        });

        $scope.$on('campaignResults', function (event, results) {
            $scope.hideSelectMsg = true;
            _selectedGridIds = [];
            $scope.pageSize = results.pageCount;
            $scope.total = results.resultCount;
            $scope.page = results.page || 0;
            $scope.start = $scope.total !== 0 ? ($scope.page * $scope.pageSize) + 1 : 0;
            var _end = ($scope.page * $scope.pageSize) + $scope.pageSize;
            $scope.end = (_end > $scope.total) ? $scope.total : _end;
        });

        $scope.$on('uncheckAll', function () {
            _selectedGridIds = [];
        });

        //Perform Action
        $scope.performActionFilter = {
            '1': {
                'text': i18n['JV_CAMPAIGNLIST_ACTIVATE'],
                'key': 'activate'
            },
            '2': {
                'text': i18n['JV_CAMPAIGNLIST_DEACTIVATE'],
                'key': 'deactivate'
            },
            '3': {
                'text': i18n['JV_CAMPAIGNLIST_DELETE'],
                'key': 'delete'
            }
        };
        $scope.currentPerformActionFilter = {};
        $scope.performAction = function (actionNumber) {
            $scope.currentPerformActionFilter = $scope.performActionFilter[actionNumber];
            if (_selectedGridIds.length > 0) {
                $scope.hideSelectMsg = true;
                if ($scope.currentPerformActionFilter.key === 'delete') {
                    //$rootScope.$broadcast('showDeleteDialog');
                    modalService.getDeleteCampaignConfirmation(_selectedGridIds.length);

                } else {
                    performAction();
                }
            } else {
                $scope.toggleActions();
                $scope.hideSelectMsg = false;
            }
        };

        // Sort Actions
        $scope.sortFilters = {
            '1': {
                'text': i18n['JV_CAMPAIGNLIST_NAME_A_Z_'],
                'key': 'name'
            },
            '2': {
                'text': i18n['JV_CAMPAIGNLIST_NAME_Z_A_'],
                'key': 'nameDesc'
            },
            '3': {
                'text': i18n['JV_CAMPAIGNLIST_DATE_RECENT'],
                'key': 'startDateDesc'
            },
            '4': {
                'text': i18n['JV_CAMPAIGNLIST_DATE_OLDEST'],
                'key': 'startDate'
            }
        };
        $scope.currentSorter = $scope.sortFilters['3'];
        $scope.setSort = function (sortNumber) {
            $scope.currentSorter = $scope.sortFilters[sortNumber];
        };

        // Watch for changes in the header filters.
        $scope.$watch('currentSorter', function (newValue, oldValue) {
            if (angular.equals(newValue, oldValue)) {
                return;
            }
            var _args = {
                sortBy: newValue.key,
                // changing the filter always sets the page to zero;
                page: 0
            };
            campaignService.getCampaigns(_args);
        });

        function performAction() {
            campaignService.noOfCampaigns = _selectedGridIds.length;
            if ($scope.currentPerformActionFilter.key === 'activate') {
                campaignService.status = 'Active';
                campaignService.buttonText = i18n['JV_CAMPAIGNLIST_ACTIVATE'];
            }
            if ($scope.currentPerformActionFilter.key === 'deactivate') {
                campaignService.status = 'Inactive';
                campaignService.buttonText = i18n['JV_CAMPAIGNLIST_DEACTIVATE'];
            }
            modalService.changeStatusConfirmation();
        }

        function completeAction() {
            return campaignService.performAction({
                'eids': _selectedGridIds,
                'action': $scope.currentPerformActionFilter.key
            });
        }

        $scope.$on('deleteCampaign', function () {
            completeAction().then(function () {
                $scope.$emit('showMessageBar', i18n.DELETED);
            });
        });

        $scope.$on('changeStatus', function () {
            completeAction();
        });

        // togglers
        $scope.toggleSorters = function () {
            $scope.sortDropDown = !$scope.sortDropDown;
        };
        $scope.toggleActions = function () {
            $scope.actionDropDown = !$scope.actionDropDown;
            $scope.hideSelectMsg = true;
        };
        var _scope = $scope;
        //Global event to let the controller know that it needs to close the drop downs.
        $scope.$on('closeDropDown', function (event, results) {
            $scope.sortDropDown = !!false;
            $scope.actionDropDown = !!false;
        });

        $scope.$on('campaignSelected', function (event, result) {
            _selectedGridIds = result;
            $scope.hideSelectMsg = true;
        });

        // pagination method.
        $scope.paginate = function (ifForward) {
            // Stop the backend calls for pagination for pages which do not exist.
            if (ifForward && ($scope.end === $scope.total)) {
                return;
            } else if ($scope.start === 1 && $scope.page === 0 && !ifForward) {
                return;
            }
            campaignService.getCampaigns({
                page: $scope.page + (ifForward ? 1 : -1)
            });
        };
    }
]);

/**
 * Grid Controller
 */
appCtrlModule.controller('CampaignGridCtrl', ['$rootScope', '$scope', 'TypeLinkMatch', 'campaignService', 'campaignStatusPrettyMap', 'campaignTypePrettyMap', '$timeout',
    function ($rootScope, $scope, TypeLinkMatch, campaignService, campaignStatusPrettyMap, campaignTypePrettyMap, $timeout) {
        //Need to add page loading image
        //$scope.campaigns = [ ];
        var _campaignsHash = {};
        $scope.selectedEids = [];

        var createCampaignHash = function () {
            for (var i = 0, j = $scope.campaigns.length; i < j; i++) {
                _campaignsHash[$scope.campaigns[i].eid] = i;
            }
        };

        $scope.$on('campaignResults', function (event, results) {
            // reinitialize the campaign Hash
            _campaignsHash = {};
            $scope.campaigns = results.resultList;
            $scope.users = {};
            results.userList.forEach(function (user) {
                $scope.users[user.EId] = user.fullName;
            });
            for (var i = 0; i < results.resultList.length; i++) {
                //campaignStatusPrettyMap, campaignTypePrettyMap
                $scope.campaigns[i].type = campaignTypePrettyMap($scope.campaigns[i].type);
            }
            createCampaignHash();
            $scope.selectedEids = [];
            //$scope.$apply();
        });

        $scope.getCampaignStatus = function (campaignKey) {
            return campaignStatusPrettyMap(campaignKey);
        };

        $scope.$on('uncheckAll', function () {

            for (var i = 0; i < $scope.selectedEids.length; i++) {
                $scope.addCheck($scope.selectedEids[i]);
            }
            $scope.selectedEids = [];
            $(':checkbox').prop('checked', false); //Change this, using jQuery
        });

        $scope.addCheck = function (eid) {
            var inArray = $.inArray(eid, $scope.selectedEids);
            if (inArray === -1) {
                //add
                $scope.selectedEids.push(eid);
            } else {
                //remove
                $scope.selectedEids.splice(inArray, 1);
            }
            $rootScope.$broadcast('campaignSelected', $scope.selectedEids);
        };

        $rootScope.$on('campaignClicks', function (event, results) {
            var results = results.resultList;
            for (var i = 0; i < results.length; i++) {
                var _index = _campaignsHash[results[i].campaignEId];
                if (_index >= 0 && !!$scope.campaigns[_index]) {
                    /* Bug : EN-3820 */
                    $scope.campaigns[_index].totalClicks = results[i].totalClicks;
                }
            }
            //$scope.$apply();
        });

        $scope.findType = function (campaignType) {
            return TypeLinkMatch[campaignType] || TypeLinkMatch['Email'];
        };
    }
]);
appCtrlModule.value('messageBarTemplateUrl', 'htm/common/messageBar.html');

/*
    Initialize the application here.
*/
$(document).ready(function () {

    jQuery.ajaxSettings.traditional = true;
    $('#jv-campaignStatus').select2($.extend({}, {
        placeholder: i18n['JV_CAMPAIGNLIST_ALL'],
        allowClear: true,
        data: [{
            id: 'IN_PROGRESS',
            text: i18n['ACTIVE']
        }, {
            id: 'PLANNING',
            text: i18n['INACTIVE']
        }],
        initSelection: function (elem, callback) {
            callback({
                text: elem.val()
            });
        }
    }, window._jvPluginDefaults.select2));

    $('#jv-campaignType').select2($.extend({}, {
        placeholder: i18n['JV_CAMPAIGNLIST_ALL'],
        allowClear: true,
        data: [{
            id: 'EMAIL',
            text: i18n['JV_CAMPAIGNLIST_EMAIL']
        }, {
            id: 'SOCIAL',
            text: i18n['JV_CAMPAIGNLIST_SOCIAL_MEDIA']
        }, {
            id: 'WEBSITE',
            text: i18n['JV_CAMPAIGNLIST_WEB_PAGE']
        }],
        initSelection: function (elem, callback) {
            callback({
                text: elem.val()
            });
        }
    }, window._jvPluginDefaults.select2));
});